/**
 * getQueryParameterByName
 *
 * @deprecated Use getSearchParameterByName to correctly get the parameter from react router.
 * @param {string} name of query parameter from url
 * @param {string} url optional, if not provided current url will be used
 * @returns {string} value of given query parameter
 */
 
export const getQueryParameterByName = (name: string, url?: string) => {
    if (!url) url = document.location.href
    // eslint-disable-next-line no-useless-escape -- legacy code
    name = name.replace(/[\[\]]/g, '\\$&')
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
         
        results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
